"use strict";
//  Copyright 2018, Venkat Peri.
//
//  Permission is hereby granted, free of charge, to any person obtaining a
//  copy of this software and associated documentation files (the
//  "Software"), to deal in the Software without restriction, including
//  without limitation the rights to use, copy, modify, merge, publish,
//  distribute, sublicense, and/or sell copies of the Software, and to permit
//  persons to whom the Software is furnished to do so, subject to the
//  following conditions:
//
//  The above copyright notice and this permission notice shall be included
//  in all copies or substantial portions of the Software.
//
//  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
//  OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
//  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
//  NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
//  DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
//  OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
//  USE OR OTHER DEALINGS IN THE SOFTWARE.
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("../types");
var Event_1 = require("./Event");
/**
 * Represents a 'call' event.
 */
var CallEvent = /** @class */ (function (_super) {
    __extends(CallEvent, _super);
    /**
     *
     * @param from - caller's id. Used by {ReplyAction} to send a response.
     * @param context - Event context
     * @param extra - Event extra data
     */
    function CallEvent(from, context, extra) {
        var _this = _super.call(this, context, extra) || this;
        _this.from = from;
        /**
         * @hidden
         * @type {Priority.Low}
         */
        _this.priority = types_1.Priority.Low;
        /**
         * @hidden
         * @type {"call"}
         */
        _this.type = "call";
        return _this;
    }
    /**
     * @hidden
     * @return {string}
     */
    CallEvent.prototype.toString = function () {
        return _super.prototype.toString.call(this) + ", from=" + this.from;
    };
    Object.defineProperty(CallEvent.prototype, "typeRoute", {
        /**
         * @hidden
         * @return {string}
         */
        get: function () {
            return this.type + "/" + this.from;
        },
        enumerable: true,
        configurable: true
    });
    return CallEvent;
}(Event_1.default));
exports.default = CallEvent;
//# sourceMappingURL=CallEvent.js.map